/* eslint-disable react-hooks/exhaustive-deps */
import { CSSProperties, Fragment, useEffect } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { useSyncState } from "src/modules/pe-basic-module/hooks/useSyncState"
import { ALIGN, CARD_FIELD_TYPE, CardFiled } from "src/modules/pe-landing-module/data/interfaces"
import { getCssDemention } from "src/libs/utilities/getCssDemention"
import { ICardProps } from "./Card"
import CardBorder from "./CardBorder"
import CardField from "./CardField"

/* Protopia Ecosystem component */ 
const CardBody = ({data, section, contentData, ...props}: ICardProps): JSX.Element => {
    const marginTop = useSyncState<string>("0")
    const grid      = useSyncState<string>( 
        !!contentData.grid 
        ? 
        `grid-template-areas: ${ contentData.grid };
        grid-template-columns: ${!!contentData.gridColumns  ? contentData.gridColumns   : "auto"};
        grid-template-rows: ${!!contentData.gridRows        ? contentData.gridRows      : "auto"};
        ${!!contentData.gridGap ? `gap: ${contentData.gridGap};`  : ``}
        display: grid;` 
        : 
        "" 
    )
    const backImage = useSyncState<string>("")
    useEffect(() => {
        const borderRadius = Array.isArray(contentData.border_radius)
            ?
            `border-top-left-radius: ${getCssDemention(contentData.border_radius[0], "2px")};
            border-bottom-left-radius: ${getCssDemention(contentData.border_radius[1], "2px")};
            border-bottom-right-radius: ${getCssDemention(contentData.border_radius[2], "2px")};
            border-top-right-radius: ${getCssDemention(contentData.border_radius[3], "2px")};`
            :
            `border-radius: ${getCssDemention(contentData.border_radius, "2px")};`  
        
        if( contentData.card_fields[0]?.type === CARD_FIELD_TYPE.MEDALLION ) { 
            marginTop.set( `margin-top: ${  getCssDemention(contentData.card_fields[0].radius / 2 + 3, "40px")};` )
        }
        backImage.set(
            contentData.order.includes( CARD_FIELD_TYPE.BACKGROUND )
                ?
                `background-image: url(${ data.value[ contentData.order.findIndex(o => o === CARD_FIELD_TYPE.BACKGROUND ) ]?.data });`
                :
                ``
        )
        addCSSClass(
            `landing-card-body-${ data.id }`,
            `.landing-card-body-${ data.id } {
                /* height: ${ !contentData.vertical_align || contentData.vertical_align === ALIGN.FULL ? "100%" : "auto" }; */
                ${ borderRadius }
                ${ marginTop.get() }
                ${ grid.get() }
                border: null!important;
            }
            .landing-card-back-${ data.id } {
                ${ backImage.get() }
                ${ 
                    data.is_back_dissolution || contentData.is_back_dissolution 
                        ? 
                        `mask-image: linear-gradient(to bottom,  rgba(255,255,255,1) 0%,rgba(255,255,255,1) 45%,rgba(255, 255, 255, 0.11) 100%,rgba(2, 2, 2, 0.11) 100%);`
                        :
                        ""
                } 
                background-color: ${data.back_color || contentData.back_color};
                ${ borderRadius }
            }
            .landing-card-back-${ data.id } .landing-card-back-muar { 

            }`
        ) 
        return () => removeCSSClass(`landing-card-body-${ data.id }`)
    }, [ contentData, data ])
    
    const style = (): CSSProperties => {
        let s: CSSProperties = {
            ...contentData.style, 
            ...data.style, 
            border: undefined
        }        
        return s
    } 
    
    
    return <div 
        className={`landing-card-body landing-card-body-${ data.id } ${ data.className || "" }` }
        style={ style() }
    >
        <div className={`landing-card-back landing-card-back-${ data.id }`}>
            <div className="landing-card-back-muar"></div>
        </div>
        {
            contentData.card_fields 
                .map((field, i) => {
                    return contentData.order.includes( field.type ) || true //TODO:: не работает в подклассах Cards.Сравнивает названия типов с псевдонимаи 
                        ?
                        <CardField 
                            key={field.id + " " + i} 
                            i={i} 
                            cardOrder={data.i} 
                            field={field} 
                            contentData={contentData}
                            value={ getCardFieldValue(field, data.value[i]) } 
                            section={section} 
                            cardData={data}
                        />
                        :
                        <Fragment key={i} />
                })
        }
        <CardBorder {...{data, section, contentData, ...props}} i={data.i} /> 
    </div>
}
export default CardBody

export const getCardFieldValue = (field: CardFiled, value: any): any => {
    if( field.pseudonym === CARD_FIELD_TYPE.BACKGROUND) {
        return {}
    } 
    return value
}